/**
 * BrüMate 尺寸选择器联动代码 - 适配 Horizon 主题
 * 在 Horizon 主题的 assets/ 目录中上传此文件，命名为 brumate-size-selector.js
 * 然后在 layout/theme.liquid 的 </body> 前引用：
 * {{ 'brumate-size-selector.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  // ============================================================
  // 商品系列尺寸映射表
  // ============================================================
  const SIZE_MAP = {
    'müv': [
      { size: '15oz', handle: 'mv-15oz' },
      { size: '25oz', handle: 'mv-25oz' },
      { size: '35oz', handle: 'mv-35oz' }
    ],
    'muv': [
      { size: '15oz', handle: 'mv-15oz' },
      { size: '25oz', handle: 'mv-25oz' },
      { size: '35oz', handle: 'mv-35oz' }
    ],
    'nav': [
      { size: '25oz', handle: 'nav-25oz' },
      { size: '35oz', handle: 'nav-35oz' }
    ],
    'resa': [
      { size: '25oz', handle: 'resa-25oz' },
      { size: '35oz', handle: 'resa-35oz' }
    ],
    'rise': [
      { size: '18oz', handle: 'rise-18oz' },
      { size: '25oz', handle: 'rise-25oz' },
      { size: '35oz', handle: 'rise-35oz' }
    ],
    'era': [
      { size: '20oz', handle: 'era-20oz' },
      { size: '30oz', handle: 'era-30oz' },
      { size: '40oz', handle: 'era-40oz' }
    ],
    'era flip': [
      { size: '30oz', handle: 'era-flip-30oz' },
      { size: '40oz', handle: 'era-flip-40oz' }
    ],
    'resa ü-turn™ replacement lid': [
      { size: '25oz', handle: 'resa-turn-replacement-lid-25oz' },
      { size: '35oz', handle: 'resa-turn-replacement-lid-35oz' }
    ],
    'universal sleeve (müv/nav/resa)': [
      { size: '25oz', handle: '25oz-universal-sleeve-mvnavresa' },
      { size: '35oz', handle: '35oz-universal-sleeve-mvnavresa' }
    ]
  };

  // ============================================================
  // 从商品标题提取系列名和当前尺寸
  // ============================================================
  function parseProductTitle(title) {
    if (!title) return null;
    const sizeMatch = title.match(/(\d+(?:\.\d+)?oz)/i);
    if (!sizeMatch) return null;
    const size = sizeMatch[1].toLowerCase();
    const baseName = title.replace(/(\d+(?:\.\d+)?oz)/i, '').replace(/\s+/g, ' ').trim().toLowerCase();
    return { baseName, size };
  }

  // ============================================================
  // 获取当前选中颜色名称
  // ============================================================
  function getCurrentColor() {
    // Horizon 主题：variant-picker 内的 radio input
    const selected = document.querySelector('variant-picker input[type="radio"]:checked');
    if (selected) return selected.value;
    return null;
  }

  // ============================================================
  // 根据目标商品 handle 和颜色名称，获取对应变体 ID
  // ============================================================
  async function getVariantByColor(handle, colorName) {
    try {
      const resp = await fetch(`/products/${handle}.json`);
      const data = await resp.json();
      const variants = data.product.variants;
      // 精确匹配颜色
      let variant = variants.find(v =>
        v.option1 && v.option1.toLowerCase() === colorName.toLowerCase()
      );
      // 模糊匹配
      if (!variant) {
        variant = variants.find(v =>
          v.option1 && v.option1.toLowerCase().includes(colorName.toLowerCase().split(' ')[0])
        );
      }
      return variant ? variant.id : (variants[0] ? variants[0].id : null);
    } catch (e) {
      return null;
    }
  }

  // ============================================================
  // 渲染尺寸选择器 UI
  // ============================================================
  function renderSizeSelector(sizeList, currentSize, currentColor) {
    if (document.getElementById('brumate-size-selector')) return;

    // Horizon 主题：插入到 variant-picker 前面
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    const wrapper = document.createElement('div');
    wrapper.id = 'brumate-size-selector';
    wrapper.style.cssText = 'margin-bottom: 24px;';

    const legend = document.createElement('div');
    legend.style.cssText = 'font-size: 14px; font-weight: 600; margin-bottom: 12px;';
    legend.textContent = 'Size';
    wrapper.appendChild(legend);

    const btnGroup = document.createElement('div');
    btnGroup.style.cssText = 'display: flex; gap: 10px; flex-wrap: wrap;';

    sizeList.forEach(({ size, handle }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = size;
      const isActive = size.toLowerCase() === currentSize.toLowerCase();
      
      // 样式匹配 Horizon 主题风格
      btn.style.cssText = `
        padding: 10px 20px;
        border-radius: 999px;
        border: 1px solid ${isActive ? '#000' : '#e5e5e5'};
        background: ${isActive ? '#000' : '#fff'};
        color: ${isActive ? '#fff' : '#000'};
        font-size: 14px;
        font-weight: 500;
        cursor: ${isActive ? 'default' : 'pointer'};
        transition: all 0.2s ease;
      `;
      
      if (!isActive) {
        btn.addEventListener('mouseenter', () => {
          btn.style.borderColor = '#000';
        });
        btn.addEventListener('mouseleave', () => {
          btn.style.borderColor = '#e5e5e5';
        });
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          btn.textContent = '...';
          const color = getCurrentColor() || currentColor || 'Dune';
          const variantId = await getVariantByColor(handle, color);
          const url = variantId
            ? `/products/${handle}?variant=${variantId}`
            : `/products/${handle}`;
          window.location.href = url;
        });
      }
      btnGroup.appendChild(btn);
    });

    wrapper.appendChild(btnGroup);
    variantPicker.parentNode.insertBefore(wrapper, variantPicker);
  }

  // ============================================================
  // 主入口
  // ============================================================
  function init() {
    // 获取 Horizon 主题自定义元素 variant-picker 上的属性
    const vp = document.querySelector('variant-picker');
    if (!vp) return;
    
    const productTitle = vp.getAttribute('data-product-title');
    if (!productTitle) return;

    const parsed = parseProductTitle(productTitle);
    if (!parsed) return;

    const { baseName, size } = parsed;

    // 查找匹配的系列
    const sizeList = SIZE_MAP[baseName];
    if (!sizeList || sizeList.length <= 1) return;

    // 尝试获取当前颜色并渲染
    const currentColor = getCurrentColor() || 'Dune';
    renderSizeSelector(sizeList, size, currentColor);
  }

  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // 延迟一点执行，确保 variant-picker 已初始化
    setTimeout(init, 100);
  }

  // 监听可能导致 DOM 重绘的事件
  const observer = new MutationObserver((mutations) => {
    if (!document.getElementById('brumate-size-selector') && document.querySelector('variant-picker')) {
      init();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
